
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/external-link-disclaimer",
      function () {
        return require("private-next-pages/external-link-disclaimer.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/external-link-disclaimer"])
      });
    }
  